import { render } from "./accountSettings.vue?vue&type=template&id=516aa476&ts=true"
import script from "./accountSettings.vue?vue&type=script&lang=ts"
export * from "./accountSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__